import styled from 'styled-components';

export const OptionsWrapper = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
`;

export const ItemWrapper = styled.div<{ $isSelected?: boolean }>`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 12px;
  border-radius: 4px;
  border: ${({ theme, $isSelected }) =>
    $isSelected ? `2px solid ${theme.colors.green7}` : `1px solid ${theme.colors.black4}`};
  background: ${({ theme, $isSelected }) =>
    $isSelected ? theme.colors.green2 : theme.colors.white};
  color: ${({ theme, $isSelected }) => ($isSelected ? theme.colors.green9 : theme.colors.black7)};
  cursor: pointer;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  min-width: 46px;
  min-height: 32px;
  transition: all 0.2s;
  user-select: none;
`;
